<section class="axis-drivers">
  <header class="axis-drivers__header">
    <div class="axis-drivers__eyebrow" *ngIf="eyebrow">{{ eyebrow }}</div>
    <h3 class="axis-drivers__title" *ngIf="sectionTitle">{{ sectionTitle }}</h3>
  </header>

  <div class="axis-drivers__state" *ngIf="loading">Loading</div>
  <div class="axis-drivers__state axis-drivers__state--error" *ngIf="!loading && errorMessage">
    {{ errorMessage }}
  </div>

  <div class="axis-drivers__list" *ngIf="!loading && !errorMessage">
    <div class="axis-drivers__row" *ngFor="let row of rows; trackBy: trackByRow">
      <div class="axis-drivers__label">{{ row.label }}</div>
      <div class="axis-drivers__badge" [ngStyle]="getStatusStyle(row.status)">
        {{ row.status }}
      </div>
    </div>

    <div class="axis-drivers__state" *ngIf="!rows.length">No driver data available.</div>
  </div>
</section>
